import { AtLeastOne } from "utils";
import {
  WpCategory,
  WpCategoryConnection,
  WpContentNode,
  WpContentNodeConnection,
  WpPost,
  WpProject_Gallery,
  WpProject_Gallery_Category,
  WpProject_Gallery_CategoryConnection,
} from "codegen";
import { graphql, useStaticQuery } from "gatsby";

/* This would be IDEAL but alas Gatsby won't let static queries have variables
 Try again I guess if Gatsby ever implements variables for static queries

const constructCPTQuery = (postType: string): string => {
  const postTypeCapitalized = String(postType).charAt(0).toUpperCase() + postType.slice(1);

  const queryString = `{
    ${postType === "post" ? "allWpCategory" : `allWp${postTypeCapitalized}Category`} {
      edges {
        node {
          slug
          uri
          id
          name
        }
      }
    }
    allWpContentNode(filter: { isContentNode: { eq: true } }, sort: { fields: date, order: DESC }) {
      edges {
        node {
          slug
          nodeType
          id
          ...${postTypeCapitalized}ListFields
        }
      }
    }
  }`;

  return queryString;
}; */

export const useCPTItems = (
  postType: string,
): {
  items: (WpContentNode & AtLeastOne<WpPost, WpProject_Gallery>)[] /* Delete me if you don't need me */;
  categories: (WpCategory | WpProject_Gallery_Category) /* Delete me if you don't need me */[];
} => {
  /** Delete unused CPTs here. Unfortunately Gatsby doesn't support variables in Static Queries */
  const allCPTItems: {
    allWpCategory?: WpCategoryConnection;
    allWpProjectGalleryCategory?: WpProject_Gallery_CategoryConnection;
    allWpContentNode: WpContentNodeConnection;
  } = useStaticQuery(graphql`
    {
      # DELETE ME IF YOU DONT HAVE PROJECTS
      allWpProjectGalleryCategory {
        edges {
          node {
            slug
            uri
            id
            name
          }
        }
      }
      allWpCategory {
        edges {
          node {
            slug
            uri
            id
            name
          }
        }
      }
      allWpContentNode(filter: { isContentNode: { eq: true } }, sort: { fields: date, order: DESC }) {
        edges {
          node {
            slug
            nodeType
            id
            ...PostFields
            ...ProjectFields
          }
        }
      }
    }
  `);

  const cptData = {
    items: allCPTItems.allWpContentNode.edges
      .filter((edge) => edge.node.nodeType.toLowerCase() === postType)
      ?.map((edge) => edge.node),
    categories:
      postType === "project"
        ? allCPTItems.allWpProjectGalleryCategory?.edges.map((edge) => edge.node)
        : allCPTItems.allWpCategory?.edges.map((edge) => edge.node),
  };

  return cptData;
};
